var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5846 6C15.2513 5.66667 14.7513 5.66667 14.418 6L8.16797 12.25L5.58464 9.66667C5.2513 9.33333 4.7513 9.33333 4.41797 9.66667C4.08464 10 4.08464 10.5 4.41797 10.8333L7.58464 14C7.7513 14.1667 7.91797 14.25 8.16797 14.25C8.41797 14.25 8.58464 14.1667 8.7513 14L15.5846 7.16667C15.918 6.83333 15.918 6.33333 15.5846 6Z",
    fill: "#3DCBB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.e700b913da128979989860c310fd2605.svg";
export { ForwardRef as ReactComponent };